/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCourseCoursesCourseIdEnrolmentsGet } from '../fn/course/api-course-courses-course-id-enrolments-get';
import { ApiCourseCoursesCourseIdEnrolmentsGet$Params } from '../fn/course/api-course-courses-course-id-enrolments-get';
import { apiCourseItemIdGet } from '../fn/course/api-course-item-id-get';
import { ApiCourseItemIdGet$Params } from '../fn/course/api-course-item-id-get';
import { apiCourseOverviewGet } from '../fn/course/api-course-overview-get';
import { ApiCourseOverviewGet$Params } from '../fn/course/api-course-overview-get';
import { apiCourseSyncPost } from '../fn/course/api-course-sync-post';
import { ApiCourseSyncPost$Params } from '../fn/course/api-course-sync-post';
import { Course } from '../models/course';
import { CourseOverviewList } from '../models/course-overview-list';
import { EnrolmentsList } from '../models/enrolments-list';
import { ImportResult } from '../models/import-result';


/**
 * Course service
 */
@Injectable({ providedIn: 'root' })
export class CourseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCourseItemIdGet()` */
  static readonly ApiCourseItemIdGetPath = '/api/course/{item_id}';

  /**
   * Get a course.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCourseItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCourseItemIdGet$Response(params: ApiCourseItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Course>> {
    return apiCourseItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a course.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCourseItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCourseItemIdGet(params: ApiCourseItemIdGet$Params, context?: HttpContext): Observable<Course> {
    return this.apiCourseItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Course>): Course => r.body)
    );
  }

  /** Path part for operation `apiCourseOverviewGet()` */
  static readonly ApiCourseOverviewGetPath = '/api/course/overview';

  /**
   * Get course overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCourseOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCourseOverviewGet$Response(params?: ApiCourseOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseOverviewList>> {
    return apiCourseOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get course overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCourseOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCourseOverviewGet(params?: ApiCourseOverviewGet$Params, context?: HttpContext): Observable<CourseOverviewList> {
    return this.apiCourseOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseOverviewList>): CourseOverviewList => r.body)
    );
  }

  /** Path part for operation `apiCourseSyncPost()` */
  static readonly ApiCourseSyncPostPath = '/api/course/sync';

  /**
   * Upsert a course.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCourseSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiCourseSyncPost$Response(params: ApiCourseSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiCourseSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a course.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCourseSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiCourseSyncPost(params: ApiCourseSyncPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiCourseSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

  /** Path part for operation `apiCourseCoursesCourseIdEnrolmentsGet()` */
  static readonly ApiCourseCoursesCourseIdEnrolmentsGetPath = '/api/course/courses/{course_id}/enrolments';

  /**
   * Returns the enrolments for a course.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCourseCoursesCourseIdEnrolmentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCourseCoursesCourseIdEnrolmentsGet$Response(params: ApiCourseCoursesCourseIdEnrolmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrolmentsList>> {
    return apiCourseCoursesCourseIdEnrolmentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the enrolments for a course.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCourseCoursesCourseIdEnrolmentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCourseCoursesCourseIdEnrolmentsGet(params: ApiCourseCoursesCourseIdEnrolmentsGet$Params, context?: HttpContext): Observable<EnrolmentsList> {
    return this.apiCourseCoursesCourseIdEnrolmentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrolmentsList>): EnrolmentsList => r.body)
    );
  }

}
